import React from 'react';
import PropTypes from 'prop-types';

import { getConnectionStatus } from './utils';

const ConnectionStatus = (props) => {
  const { latestTimestamp } = props;

  const tagStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 6px',
    gap: 3,
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 400,
    width: 'fit-content',
  };

  const status = getConnectionStatus(latestTimestamp);

  return (
    <div
      style={{
        ...tagStyle,
        ...status.style,
      }}
    >
      {status.icon}
      <span>
        {status.label}
      </span>
    </div>
  );
};

ConnectionStatus.propTypes = {
  latestTimestamp: PropTypes.number,
};

ConnectionStatus.defaultProps = {
  latestTimestamp: 0,
};

export default ConnectionStatus;
